import { render, staticRenderFns } from "./carouseCardBlogGeneral.vue?vue&type=template&id=1668360c&scoped=true"
import script from "./carouseCardBlogGeneral.vue?vue&type=script&lang=js"
export * from "./carouseCardBlogGeneral.vue?vue&type=script&lang=js"
import style0 from "./carouseCardBlogGeneral.vue?vue&type=style&index=0&id=1668360c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1668360c",
  null
  
)

export default component.exports